import { Component, OnInit } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Category, Package, PackageStatus } from 'src/app/core/models/package.model';
import { Pagination, PaginationRequest } from 'src/app/core/models/pagination.model';
import { LicenseService } from 'src/app/core/services/license.service';
import { UserService } from 'src/app/core/services/user.service';
import { User } from 'src/app/core/models/user.model';
import * as utils from 'src/app/shared/helpers/utils';
import { Router } from '@angular/router';
import { Entity } from 'src/app/core/models/entity.model';
import { LoginService } from 'src/app/core/services/login.service';
import { PackageType } from 'src/app/core/models/package-type.model';
import { CsvDataService } from 'src/app/core/services/export.service';
import { CsvPackage } from 'src/app/core/models/csv.model';
import { DdbbUtils } from 'src/app/shared/helpers/utils';
import { License } from 'src/app/core/models/license.model';
import { ConfigService } from 'src/app/core/services/config.service';
import { AdminService } from 'src/app/core/services/admin.service';

@Component({
  selector: 'hbo-package-list',
  templateUrl: './package-list.component.html',
  styleUrls: ['./package-list.component.scss']
})
export class PackageListComponent implements OnInit {

  entity!: Entity;

  packages$ = new Observable<Pagination<Package>>;
  packagesCsv$ = new Observable<Pagination<Package>>;

  user: User = utils?.localStorageGetItem('user');

  columns: string[] = [];

  entities_filter!: Entity[];
  packageTypes!: PackageType[];
  packageStatus!: PackageStatus[];
  status_filter!: string[];
  category_filter!: Category[];

  action = 'reassign';

  packageIdSelected!: number;
  modalConfirm: string = 'package';
  noDevicePackageToReassign: Package | null = null;
  packageToAssign: Package | null = null;

  globalPagination!: PaginationRequest;

  constructor(
    public router: Router,
    private ddbbUtils: DdbbUtils,
    private loginService: LoginService,
    private licenseService: LicenseService,
    private userService: UserService,
    private csvDataService: CsvDataService,
    public configSvc: ConfigService,
    private adminSvc: AdminService
  ) {
    this.user.childEntities = this.configSvc.currentConfigValue.childEntities;
    this.entity = this.user.entity;
  }

  get teams() {
    return this.configSvc.currentConfigValue.teams ?? [];
  }

  ngOnInit() {
    if (!this.configSvc.currentConfigValue.teams) {
      this.userService.getTeams({ perPage: -1 }).pipe(map(res => {
        this.configSvc.setConfigParamsValue('teams', res.data);
      })).subscribe();
    }
    //this.searchPackages();
    //this.ddbbUtils.getEntityChilds(this.user.entityId).then(result => {
    /*this.user.childEntities = result;
    utils.localStorageSetItem('user', this.user);*/
    this.licenseService.currentPackageConfigValue.pagination
      ? this.searchPackages(this.licenseService.currentPackageConfigValue.pagination)
      : null;
    const storagePackageFilter = JSON.parse(localStorage.getItem('packageFilter')!) as PaginationRequest
    if (storagePackageFilter) {
      // Parse filter_params if it's a string
      if (storagePackageFilter.filter_params && typeof storagePackageFilter.filter_params === 'string') {
        storagePackageFilter.filter_params = JSON.parse(storagePackageFilter.filter_params as unknown as string);
      }
      this.licenseService.setCurrentPackageParamConfig('pagination', storagePackageFilter);
      this.searchPackages(storagePackageFilter);
    } else {
      this.searchPackages();
    }
    //});
  }

  searchPackages(pagination?: PaginationRequest) {
    //this.packages$ = this.licenseService.indexPackages(pagination ?? {});
    //columns by role
    switch (this.user.roleId) {
      case 1:
        //include actions
        //this.columns = ['id', 'distributor', 'headOffice', 'opticalShop', 'type', 'category', 'status', 'assignedAt', 'remainingTestDays', 'renewalDate','period', 'device', 'actions', 'details']
        this.configSvc.currentConfigValue.debug
          ? this.columns = ['id', 'distributor', 'headOffice', 'opticalShop', 'type', 'category', 'status', 'assignedAt', 'remainingTestDays', 'renewalDate', 'period', 'device', 'details']
          : this.columns = ['id', 'distributor', 'headOffice', 'opticalShop', 'type', 'category', 'status', 'assignedAt', 'remainingTestDays', 'renewalDate', 'device', 'details']
        break;
      case 2:
        this.columns = ['id', 'headOffice', 'opticalShop', 'type', 'category', 'status', 'remainingTestDays', 'renewalDate', 'device', 'details']
        break;
      case 3:
        this.columns = ['id', 'opticalShop', 'type', 'category', 'status', 'remainingTestDays', 'renewalDate', 'device', 'details']
        break;
      case 4:
        this.columns = ['id', 'type', 'category', 'status', 'remainingTestDays', 'renewalDate', 'details']
        break;
    }
    this.loginService.userStore.subscribe(async user => {

      this.entities_filter = user.childEntities!;
      //this.licenseService.setCurrentPackageParamConfig('partners',this.entities_filter);
      //get packages types
      if (!this.packageTypes) {
        !this.configSvc.currentConfigValue.packageTypes
          ? this.licenseService.getPackageTypes().subscribe(packageTypes => {
            this.packageTypes = packageTypes.data;
            this.configSvc.setConfigParamsValue('packageTypes', this.packageTypes);
            this.filterPolicy()
          })
          : (
            this.packageTypes = this.configSvc.currentConfigValue.packageTypes,
            this.filterPolicy()
          )
      }
      //!this.packageStatus ? this.licenseService.getPackageStatus().subscribe(packageStatus => this.packageStatus = packageStatus.data):null;
      this.packageStatus = [
        {
          "id": 1,
          "name": "Assigned"
        },
        {
          "id": 2,
          "name": "Test"
        },
        {
          "id": 3,
          "name": "Active"
        },
        {
          "id": 4,
          "name": "Inactive Request"
        },
        {
          "id": 5,
          "name": "Inactive"
        },
        {
          "id": 6,
          "name": "In Upgrade"
        }
      ];
      this.category_filter = [{ id: 1, name: 'OPERATIVE' }, { id: 2, name: 'DEMO' }];
      const queryStringParams: PaginationRequest = {};
      const queryStringParamsArray: any[] = [];
      pagination?.filter_params
        ? pagination.filter_params!['entities'] = this.licenseService.currentPackageConfigValue.shops_selected
        : null;
      //--------------------partners--------------------------------//
      let partners: number[];
      pagination?.filter_params && pagination?.filter_params!['entities'] && pagination?.filter_params!['entities'].length
        ? partners = pagination.filter_params!['entities'].map((entity: { internalCode: any; id: any; }) => Number(entity.id))
        : this.user.roleId === 1
          ? partners = []
          : partners = [Number(user.entity.id)].concat(this.user.childEntities!.filter((entity: Entity) => entity.entityTypeId === 3).map((entity: Entity) => entity.id));//including if distributor the headoffices
      pagination && pagination!.entities
        ? pagination!.entities = JSON.stringify(partners)
        : null;
      //--------------------partners--------------------------------//
      pagination?.search ? queryStringParams.search = pagination?.search : null;
      pagination?.sort
        ? queryStringParams.sort = pagination?.sort
        : null;
      pagination?.order
        ? queryStringParams.order = pagination?.order
        : null;
      let finalPagination;
      if (pagination?.filter_params) {
        Object.keys(pagination?.filter_params!).map(key => pagination[this.mapPaginationLabel(key)] = pagination?.filter_params![key]);
        finalPagination = JSON.parse(JSON.stringify(pagination));
        partners.length ? finalPagination.entities = JSON.stringify(partners) : null;
        delete finalPagination.filter_params;
        delete finalPagination.showFilters;
      } else {
        finalPagination = {
          'entities': partners.length ? JSON.stringify(partners) : null,
          // Keep team scope: the table drops empty filter_params when it is recreated
          teamId: pagination?.['teamId']
        };
      };
      !finalPagination
        ? finalPagination = { perPage: pagination?.perPage! || 0, page: pagination?.page || 1 }
        : (
          finalPagination.page = pagination?.page! || 1,
          finalPagination.perPage = pagination?.perPage! || 0
        )
      /*if (!pagination || !pagination.filter_params || !pagination.filter_params['entities'] || !pagination.filter_params['entities'].length) {
        //finalPagination.entities = `[${this.user.entity.id}]`;
        let entitiesIds: number[] = [];
        this.user.childEntities.length ? entitiesIds = this.user.childEntities.map(a => a.id) : null;
        entitiesIds.push(this.user.entity.id);
        finalPagination.entities =  JSON.stringify(partners)
      }*/
      finalPagination.sort = pagination?.sort;
      finalPagination.order = pagination?.order;

      if (!finalPagination.sort && !finalPagination.order) {
        finalPagination.sort = 'id';
        finalPagination.order = 'desc';
      }

      this.configSvc.currentConfigValue.packageEntitiesSelectedApplied
        ? finalPagination.entities = JSON.stringify(this.configSvc.currentConfigValue.packageEntitiesSelectedApplied.map((item: any) => item.id))
        : null;

      this.globalPagination = finalPagination!;

      this.packages$ = (await this.licenseService.indexPackages(finalPagination ?? { order: 'desc' })).pipe(map(packages => ({
        total: packages.total,
        perPage: pagination?.perPage || 10,
        currentPage: pagination?.page || 1,
        lastPage: 1,
        from: 1,
        to: packages.data.length,
        data: packages.data,
        sort: pagination?.sort || queryStringParams.sort,
        search: pagination?.search || queryStringParams.search,
        order: pagination?.order || queryStringParams.order,
        showFilters: pagination?.showFilters || false,
        selectorEntitiesSearch: pagination?.selectorEntitiesSearch || '',
        filter_params: pagination?.filter_params || queryStringParams.filter_params,
        entities: pagination?.entities || undefined
      })));
    });


  }

  mappingQueryLabels: any = { category: 'category', packageType: 'type', status: 'status', packageInactive: 'inactive', entities: 'entities', pendingAssignment: 'pendingAssignment' }

  mapPaginationLabel(_key: string) {
    return this.mappingQueryLabels[_key]
  }

  getClientName(_id: any) {
    if (this.user.role?.id != 4) {
      return `${this.user.childEntities!.find(child => child.id == _id)?.name}(${_id})`
    } else {
      return `${this.user.entity.name}(${_id})`
    }

  }
  downloadCsv() {
    const perPage = 500;
    let page = 1;
    let lastPage = 0;
    let total = 0;
    const pagination: PaginationRequest = this.globalPagination;
    pagination.perPage = perPage;
    const rows: CsvPackage[] = [];
    this.iterateCSVLicenses(pagination, perPage, page, lastPage, total, rows)
    //this.fitService.updateReference(fit.TagID, fit.internalRef).subscribe();
    //this.packagesCsv$  =

  }

  iterateCSVLicenses = (_pagination: PaginationRequest, _perPage: number, _page: number, _lastPage: number, _total: number, _rows: CsvPackage[]) => {
    _pagination.page = _page;
    this.licenseService.indexPackages(_pagination).subscribe(packages => {
      _total = packages.total
      _lastPage = packages.lastPage
      console.log(_rows.length);
      this.setCSVRowsLicenses(packages.data, _rows)
      if (_page == _lastPage) {
        switch (this.user.roleId) {
          case 1:
            this.csvDataService.downloadFile(_rows, 'download', ['Id_Licence', 'Licence_type', 'Id_Package', 'Package_type', 'Distributor', 'Head_Officer', 'Optical_Shop', 'Category', 'Status', 'Assigned_date', 'Test_start_date', 'Test_days', 'Remaining_test_days', 'Activation_date', 'Inact_Request_date', 'Inactivation_date', 'Renewal_date', 'Last_renewal_date', 'Linked_device'])
            break;
          default:
            this.csvDataService.downloadFile(_rows, 'download', ['Id_Licence', 'Licence_type', 'Id_Package', 'Package_type', 'Distributor', 'Head_Officer', 'Optical_Shop', 'Category', 'Status', 'Assigned_date', 'Test_start_date', 'Test_days', 'Remaining_test_days', 'Activation_date', 'Inact_Request_date', 'Inactivation_date', 'Renewal_date', 'Linked_device'])
            break;
        }
      } else {
        _page++;
        this.iterateCSVLicenses(_pagination, _perPage, _page, _lastPage, _total, _rows)
      }

    });
  }

  setCSVRowsLicenses = (_data: Package[], _rows: CsvPackage[]) => {
    for (const _package of _data) {
      for (const license of _package.licenses) {
        switch (this.user.roleId) {
          case 1:
            _rows.push({
              Id_Licence: license.id.toString(),
              Licence_type: license.app?.name,
              Id_Package: _package.id?.toString(),
              Package_type: _package.packageType?.name,
              Distributor: this.getName('dist', _package.owner?.id!, _package.assignedEntityId)!.toString().replace(',', ' '),
              Head_Officer: this.getName('head', _package.owner?.id!, _package.assignedEntityId)!.toString().replace(',', ' '),
              Optical_Shop: this.getName('shop', _package.assignedEntityId)!.toString().replace(',', ' '),
              Category: _package.category.name,
              Status: license.licenseStatus?.name,
              Assigned_date: this.formatDateForCsv(license.statusDate?.assignedDate),
              Test_start_date: this.formatDateForCsv(license.statusDate?.testStartDate),
              Test_days: _package.testDays!.toString(),
              Remaining_test_days: license.testDays!.toString(),
              Activation_date: this.formatDateForCsv(license.statusDate?.activationDate),
              Inact_Request_date: this.formatDateForCsv(license.statusDate?.inactiveRequestDate),
              Inactivation_date: this.formatDateForCsv(license.statusDate?.inactiveDate),
              Renewal_date: this.formatDateForCsv(license.statusDate?.renewalInvoiceableDate),
              Last_renewal_date: this.formatDateForCsv(license.statusDate?.lastRenewalDate),
              Linked_device: _package.device?.serialNumber ?? '...'
            });
            break;
          default:
            _rows.push({
              Id_Licence: license.id.toString(),
              Licence_type: license.app?.name,
              Id_Package: _package.id?.toString(),
              Package_type: _package.packageType?.name,
              Distributor: this.getName('dist', _package.owner?.id!, _package.assignedEntityId)!.toString().replace(',', ' '),
              Head_Officer: this.getName('head', _package.owner?.id!, _package.assignedEntityId)!.toString().replace(',', ' '),
              Optical_Shop: this.getName('shop', _package.assignedEntityId)!.toString().replace(',', ' '),
              Category: _package.category.name,
              Status: license.licenseStatus?.name,
              Assigned_date: this.formatDateForCsv(license.statusDate?.assignedDate),
              Test_start_date: this.formatDateForCsv(license.statusDate?.testStartDate),
              Test_days: _package.testDays!.toString(),
              Remaining_test_days: license.testDays!.toString(),
              Activation_date: this.formatDateForCsv(license.statusDate?.activationDate),
              Inact_Request_date: this.formatDateForCsv(license.statusDate?.inactiveRequestDate),
              Inactivation_date: this.formatDateForCsv(license.statusDate?.inactiveDate),
              Renewal_date: this.formatDateForCsv(license.statusDate?.renewalInvoiceableDate),
              Linked_device: _package.device?.serialNumber ?? '...'
            });
            break;
        }

      }
    }
  }

  escapeForCSV = (value: string) => {
    if (value == null) return '';

    const str = String(value);
    const needsQuotes = /[",\n\r]/.test(str);

    let escaped = str.replace(/"/g, '""'); // escape double quotes

    return needsQuotes ? `"${escaped}"` : escaped;
  }

  formatDateForCsv = (value: string | undefined | null): string => {
    if (!value || value === '...') return '...';

    // Si ya es una fecha en formato YYYY-MM-DD, devolverla tal cual
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;

    // Convertir fecha ISO a YYYY-MM-DD
    const date = new Date(value);
    if (isNaN(date.getTime())) return '...';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  setCSVRowsPackages = (_data: Package[], _rows: CsvPackage[]) => {
    const decoder = new TextDecoder('utf-8');
    for (const _package of _data) {
      switch (this.user.roleId) {
        case 1:
          _rows.push({
            Id_package: _package.id.toString(),
            Package_type: _package.packageType?.name,
            Distributor: this.escapeForCSV(this.getName('dist', _package.owner?.id!, _package.assignedEntityId)!.toString()),
            Head_Officer: this.escapeForCSV(this.getName('head', _package.owner?.id!, _package.assignedEntityId)!.toString()),
            Optical_Shop: this.escapeForCSV(this.getName('shop', _package.assignedEntityId)!.toString()),
            Category: _package.category.name,
            Status: _package.status?.name,
            Assigned_date: this.formatDateForCsv(_package.assignedAt),
            Test_start_date: this.formatDateForCsv(_package.testStartDate),
            Test_days: _package.testDays!.toString(),
            Remaining_test_days: _package.remainingTestDays!.toString(),
            Activation_date: this.formatDateForCsv(_package.activationDate),
            Inact_Request_date: this.formatDateForCsv(_package.inactiveRequestDate),
            Inactivation_date: this.formatDateForCsv(_package.inactiveDate),
            Renewal_date: this.formatDateForCsv(_package.renewalInvoiceableDate),
            Last_renewal_date: this.formatDateForCsv(_package.lastRenewalDate),
            Linked_device: _package.device?.serialNumber ?? '...',
            Package_origin: _package.packageOriginId ?? '...',
            Package_upgrade: _package.packageUpgradeId ?? '...'
          });
          break;
        case 2:
          _rows.push({
            Id_package: _package.id.toString(),
            Package_type: _package.packageType?.name,
            Head_Officer: this.escapeForCSV(this.getName('head', _package.owner?.id!, _package.assignedEntityId)!.toString()),
            Optical_Shop: this.escapeForCSV(this.getName('shop', _package.assignedEntityId)!.toString()),
            Category: _package.category.name,
            Status: _package.status?.name,
            Assigned_date: this.formatDateForCsv(_package.assignedAt),
            Test_start_date: this.formatDateForCsv(_package.testStartDate),
            Test_days: _package.testDays!.toString(),
            Remaining_test_days: _package.remainingTestDays!.toString(),
            Activation_date: this.formatDateForCsv(_package.activationDate),
            Inact_Request_date: this.formatDateForCsv(_package.inactiveRequestDate),
            Inactivation_date: this.formatDateForCsv(_package.inactiveDate),
            Renewal_date: this.formatDateForCsv(_package.renewalInvoiceableDate),
            Linked_device: _package.device?.serialNumber ?? '...',
            Package_origin: _package.packageOriginId ?? '...',
            Package_upgrade: _package.packageUpgradeId ?? '...'
          });
          break;
        case 3:
          _rows.push({
            Id_package: _package.id.toString(),
            Package_type: _package.packageType?.name,
            Optical_Shop: this.escapeForCSV(this.getName('shop', _package.assignedEntityId)!.toString()),
            Category: _package.category.name,
            Status: _package.status?.name,
            Assigned_date: this.formatDateForCsv(_package.assignedAt),
            Test_start_date: this.formatDateForCsv(_package.testStartDate),
            Test_days: _package.testDays!.toString(),
            Remaining_test_days: _package.remainingTestDays!.toString(),
            Activation_date: this.formatDateForCsv(_package.activationDate),
            Inact_Request_date: this.formatDateForCsv(_package.inactiveRequestDate),
            Inactivation_date: this.formatDateForCsv(_package.inactiveDate),
            Renewal_date: this.formatDateForCsv(_package.renewalInvoiceableDate),
            Linked_device: _package.device?.serialNumber ?? '...',
            Package_origin: _package.packageOriginId ?? '...',
            Package_upgrade: _package.packageUpgradeId ?? '...'
          });
          break;
        default:
          _rows.push({
            Id_package: _package.id.toString(),
            Package_type: _package.packageType?.name,
            Distributor: this.escapeForCSV(this.getName('dist', _package.owner?.id!, _package.assignedEntityId)!.toString()),
            Head_Officer: this.escapeForCSV(this.getName('head', _package.owner?.id!, _package.assignedEntityId)!.toString()),
            Optical_Shop: this.escapeForCSV(this.getName('shop', _package.assignedEntityId)!.toString()),
            Category: _package.category.name,
            Status: _package.status?.name,
            Assigned_date: this.formatDateForCsv(_package.assignedAt),
            Test_start_date: this.formatDateForCsv(_package.testStartDate),
            Test_days: _package.testDays!.toString(),
            Remaining_test_days: _package.remainingTestDays!.toString(),
            Activation_date: this.formatDateForCsv(_package.activationDate),
            Inact_Request_date: this.formatDateForCsv(_package.inactiveRequestDate),
            Inactivation_date: this.formatDateForCsv(_package.inactiveDate),
            Renewal_date: this.formatDateForCsv(_package.renewalInvoiceableDate),
            Linked_device: _package.device?.serialNumber ?? '...',
            Package_origin: _package.packageOriginId ?? '...',
            Package_upgrade: _package.packageUpgradeId ?? '...'
          });
          break;
      }
    }
  }


  getName(_type: string, _entitiId?: number | null | undefined, _assignedId?: number) {
    const entity = this.user.childEntities!.find((entity: Entity) => entity.id == _entitiId);
    const assigned = this.user.childEntities!.find((entity: Entity) => entity.id == _assignedId);
    switch (_type) {
      case 'dist':
        if (!_entitiId) return '<i class="bi bi-question-circle-fill text-danger fs-5"></i>'
        if (_entitiId != 2) return this.getParent(2, _assignedId).name
        else return entity?.name
      case 'head':
        if (!_entitiId) return '<i class="bi bi-question-circle-fill text-danger fs-5"></i>'
        if (entity?.entityTypeId != 3)
          if (assigned?.entityTypeId == 3) return assigned!.name
          else return '···'
        else return entity?.name
      case 'shop':
        if (entity?.entityTypeId == 4 && !entity?.isBase) {
          return entity?.name
        } else {
          switch (this.user.roleId) {
            case 1:
            case 2:
            case 3:
              //comprobar si está asignada al headoffice
              if (entity?.name === undefined && _entitiId !== this.user.entityId) return '<i class="bi bi-question-circle-fill text-danger fs-5"></i>'
              else return '···'
            case 4:
              if (entity?.name === undefined) return '<i class="bi bi-question-circle-fill text-danger fs-5"></i>'
              else return '···'
            default:
              break;
          }

        }
    }
    return _entitiId
  }

  downloadPackagesCsv() {
    const perPage = 500;
    let page = 1;
    let lastPage = 0;
    let total = 0;
    const pagination: PaginationRequest = this.globalPagination;
    pagination.perPage = perPage;
    const rows: CsvPackage[] = [];
    this.iterateCSVPackages(pagination, perPage, page, lastPage, total, rows)
    //this.fitService.updateReference(fit.TagID, fit.internalRef).subscribe();
    //this.packagesCsv$  =

  }

  iterateCSVPackages = (_pagination: PaginationRequest, _perPage: number, _page: number, _lastPage: number, _total: number, _rows: CsvPackage[]) => {
    _pagination.page = _page;
    this.licenseService.indexPackages(_pagination).subscribe(packages => {
      _total = packages.total
      _lastPage = packages.lastPage
      console.log(_rows.length);
      this.setCSVRowsPackages(packages.data, _rows)
      if (_page == _lastPage) {
        switch (this.user.roleId) {
          case 1:
            this.csvDataService.downloadFile(_rows, 'download', ['Id_package', 'Package_type', 'Distributor', 'Head_Officer', 'Optical_Shop', 'Category', 'Status', 'Assigned_date', 'Test_start_date', 'Test_days', 'Remaining_test_days', 'Activation_date', 'Inact_Request_date', 'Inactivation_date', 'Renewal_date', 'Last_renewal_date', 'Linked_device', 'Package_origin', 'Package_upgrade'])
            break;
          case 2:
            this.csvDataService.downloadFile(_rows, 'download', ['Id_package', 'Package_type', 'Head_Officer', 'Optical_Shop', 'Category', 'Status', 'Assigned_date', 'Test_start_date', 'Test_days', 'Remaining_test_days', 'Activation_date', 'Inact_Request_date', 'Inactivation_date', 'Renewal_date', 'Linked_device', 'Package_origin', 'Package_upgrade'])
            break;
          case 3:
            this.csvDataService.downloadFile(_rows, 'download', ['Id_package', 'Package_type', 'Optical_Shop', 'Category', 'Status', 'Assigned_date', 'Test_start_date', 'Test_days', 'Remaining_test_days', 'Activation_date', 'Inact_Request_date', 'Inactivation_date', 'Renewal_date', 'Linked_device', 'Package_origin', 'Package_upgrade'])
            break;
          default:
            this.csvDataService.downloadFile(_rows, 'download', ['Id_package', 'Package_type', 'Distributor', 'Head_Officer', 'Optical_Shop', 'Category', 'Status', 'Assigned_date', 'Test_start_date', 'Test_days', 'Remaining_test_days', 'Activation_date', 'Inact_Request_date', 'Inactivation_date', 'Renewal_date', 'Linked_device', 'Package_origin', 'Package_upgrade'])
            break;
        }
      } else {
        _page++;
        this.iterateCSVPackages(_pagination, _perPage, _page, _lastPage, _total, _rows)
      }

    });
  }

  getParent(_limit: number, _entitieId?: number) {
    const entityMatch: Entity = this.user.childEntities!.find((entity: Entity) => entity.id == _entitieId)!;
    if (entityMatch) {
      if (entityMatch!.entityTypeId == _limit) {
        return entityMatch
      } else {
        const result: Entity = this.getParent(_limit, entityMatch.parentEntityId)!
        if (result.entityTypeId == _limit) {
          return result
        }

      }
    } else {
      const noParent: Entity = new Entity;
      noParent.name = '...'
      return noParent
    }

    return entityMatch;

  }

  reassign(e: { packageId: number }) {
    if (e) this.router.navigate(['/licenses/packages/edit/' + + (e.packageId ? e.packageId : '')]);
  }

  onNoDeviceReassignConfirmed(): void {
    this.noDevicePackageToReassign = null;
    this.refresh();
  }

  filterPackageTypesByPolicy(entityId: number) {
    let errorPolicy!: string;
    this.licenseService.showPolicy(entityId).subscribe({
      next: policy => {
        errorPolicy = policy.error?.error;
        if (errorPolicy) {
          switch (errorPolicy) {
            case 'Policy not found':
              this.packageTypes = this.packageTypes.filter(packageType => !packageType.private)
              break;
            default:
              break;
          }
        } else {
          if (policy.packagePolicies) {
            this.packageTypes = this.packageTypes.filter(packageType => policy.packagePolicies.some(packagePolicy => packagePolicy.packageTypeId === packageType.id));
          }
        }
      },
      error: () => this.packageTypes = this.packageTypes.filter(packageType => !packageType.private)
    });
  }

  selectedPackage(_id: number) {
    this.packageIdSelected = _id;
  }

  delete() {
    this.licenseService.destroyPackage(this.packageIdSelected).subscribe(res => {
      this.searchPackages();
    });
  }

  setPackageLabelDate(_package: Package, _label: string) {
    if (_package.licenses) {
      return _package.licenses.reduce<Date | null>((min, item) => {
        if (item.statusDate) {
          if (item.statusDate[_label]) {
            const date = new Date(item.statusDate[_label]);
            if (min)
              min = date < min ? date : min;
            else
              min = date;
          }
          return min;
        } else {
          return null
        }

      }, null);
    } else {
      return null
    }

  }

  refresh() {
    this.searchPackages();
  }

  licenseInactiveData!: string;

  // Which same-group warning wording the reassign modal asked for.

  licenseWarningNoDevice = false;
  setLicenseData(e: { licenseData: string; noDevice?: boolean }) {
    this.licenseInactiveData = e.licenseData;
    // The admin wording asks them to confirm a second device, which says nothing for a
    // no-device package: that flow needs its own text.
    this.licenseWarningNoDevice = !!e.noDevice;
  }

  // Both reassign entry points share the warning modals, so reopen whichever one is active
  get activeReassignModal(): string {
    return this.packageToAssign ? '#reassignModal-assign' : '#reassignModal';
  }

  backConfirmReassignPackageModal(e: any) {
    utils.forceModal(this.activeReassignModal, false);
    utils.forceModal('#confirmationModal-admin-some-license', true);
  }

  show(e: any) {
    //this.haveLicencesSameGroup = false;
    let newButton = document.createElement('button');
    newButton.setAttribute('data-bs-toggle', 'modal');
    newButton.setAttribute('data-bs-target', this.activeReassignModal);
    document.body.appendChild(newButton);
    newButton.click();
    document.body.removeChild(newButton);
  }

  invoiceable(_package: Package) {
    //if (_package.renewalDate && new Date(_package.renewalDate).setHours(0,0,0,0) > new Date().setHours(0,0,0,0)) return true
    if (_package.renewalInvoiceableDate) return true
    else return false
  }

  inheritedLicensesInvoiceable(_package: Package) {
    const inheritedLicenses = _package.licenses.filter((license: License) => license.firstPackageId !== license.packageId);
    const newLicenses = _package.licenses.filter((license: License) => license.firstPackageId === license.packageId);
    if (!inheritedLicenses.length) {
      return false
    } else {
      const firstInheriteLicense = inheritedLicenses[0];
      if (_package.packageStatusId === 6 && newLicenses.length && _package.renewalDate && new Date(firstInheriteLicense!.statusDate!.renewalPersDate).setHours(0, 0, 0, 0) < new Date(_package.renewalPersDate).setHours(0, 0, 0, 0)) return true
      else return false
    }


  }
  filterPolicy = () => {
    switch (this.entity.entityTypeId) {
      case 3:
        this.filterPackageTypesByPolicy(this.entity.parentEntityId);
        break;
      default:
        this.filterPackageTypesByPolicy(this.entity.id);
        break
    }
  }

  toogleAdmin = () => {
    this.adminSvc.setCurrentAdminParam('show', !this.adminSvc.currentAdminValue.show);
    console.log(this.adminSvc.currentAdminValue);
  }


}
